module.exports = __webpack_public_path__ + "media/images/dummy_tokusyu-09bd52740c6fe681b06fb9b9e5773817.png";